import api from './api';

export const getDriverByDriverCode = (driverCode: string, parcelCode: string) =>
  api.get({
    path: `/drivers/${driverCode}`,
    query: {
      parcelCode,
    },
  });

export const getDriverFeedbackByDriverCode = (
  driverCode: string,
  parcelCode: string
) =>
  api.get({
    path: `/drivers/${driverCode}/rating`,
    query: {
      parcelCode,
    },
  });
